export default {
    methods: {
        sim_state_title(sim_state){
          if (!sim_state) return ""
          let string = `Network: ${sim_state.signal}\n`
          if (sim_state.oper) string += `oper: ${sim_state.oper}\n`
          if (sim_state.oper_id) string += `oper_id: ${sim_state.oper_id}\n`
          if (sim_state.lte_band) string += `lte_band: ${sim_state.lte_band}\n`
          if (sim_state.rssi) string += `rssi: ${sim_state.rssi}\n`
          if (sim_state.sinr) string += `sinr: ${sim_state.sinr}\n`
          if (sim_state.rsrq) string += `rsrq: ${sim_state.rsrq}\n`
          if (sim_state.rsrp) string += `rsrp: ${sim_state.rsrp}\n`
          if (sim_state.temp) string += `temp: ${sim_state.temp}°C\n`
          return string
        },

        compareNumbers(a, b) {
            if (this.filter_type === undefined || this.filter_type === '') return 0
            let left = a[this.filter_type]
            let right = b[this.filter_type]
            // TextTable stores cell contents in { value, ... } objects.
            if (left && typeof left === 'object') left = left.value
            if (right && typeof right === 'object') right = right.value
            left = left == null ? '' : left
            right = right == null ? '' : right
            const result = left !== '' && right !== ''
                && Math.abs(Number(left)) <= Number.MAX_SAFE_INTEGER && Math.abs(Number(right)) <= Number.MAX_SAFE_INTEGER
                ? Number(left) - Number(right)
                : String(left).localeCompare(String(right), this.$root.language, {numeric: true, sensitivity: 'base'})
            return this.filter_asc === "asc" ? -result : result
        },

        change_filter(type) {
            if (this.filter_type === type) {
                this.filter_asc = this.filter_asc === 'asc' ? 'desc' : 'asc'
            } else {
                this.filter_type = type
            }
        },

        getColorSimcardProfileStatuses(status_id) {
            return this.$store.getters.getSimcardProfileStatusesById(status_id).color
        },

        getTextSimcardProfileStatuses(status_id) {
            if (!status_id)
                return "simcard_profile.statuses.undefined"

            switch (status_id) {
                case -1:
                    return "simcard_profile.statuses.undefined"
                case 1:
                    return "simcard_profile.statuses.active"
                case 2:
                    return "simcard_profile.statuses.blocked"
                case 3:
                    return "simcard_profile.statuses.prepare"
                case 4:
                    return "simcard_profile.statuses.stop"
                default:
                    return ""
            }
        }
    }
}
